import { MULTI_CARRIER_ENABLED } from 'core/constants/environment'
import getMultiCarrierEligibility from 'core/services/getMultiCarrierEligibility'
import store from 'utils/store/withMiddleware'

async function updateMultiCarrierEligibility() {
  const storage = store.getState()
  if (MULTI_CARRIER_ENABLED) {
    const multiCarrierEligibility = await getMultiCarrierEligibility(
      storage.hcStorage.location?.state_acronym,
      storage.hcStorage.agent_id
    )
    const eligibilityMonths = multiCarrierEligibility.maxDuration
    const eligibilityBool = multiCarrierEligibility.multiCarrier
    const newState: Partial<Pivot.State> = store.update({
      eligibilityMonths: eligibilityMonths,
      eligibilityBool: eligibilityBool
    })
    return newState
  } else {
    return storage
  }
}

export default updateMultiCarrierEligibility
